import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractAutocompleteInput} from "../abstract-autocomplete-input";
import {FUIOptionsService} from "../../../framework/options.service";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineAutocompleteInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-autocomplete-input",
    styleUrls: ["./inline-autocomplete-input.component.scss"],
    templateUrl: "./inline-autocomplete-input.component.html"
})
export class FUIInlineAutocompleteInputComponent extends FUIAbstractAutocompleteInput {
    constructor(changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService) {
        super(changeDetectorRef, elementRef, eventsService, optionsService);
    }
}
